<template>
  
  <main class="main">
    
    <div class="container">

      <router-link class="link link_back-to-news" to="/news">Back to news</router-link>

      <h1 class="title title_h1_news-item-page">{{ title }}</h1>

      <div class="news-item news-item_full">
        
        <div class="news-item__wrapper">

          <div class="news-item__date">{{ date }}</div>

          <div class="news-item__content">{{ shortDesc }}</div>

        </div>

      </div>

    </div>

    <div class="news-item news-item_full">
      
      <div
        :style="{ 'background-image' : `url(${ image })` }"
        class="news-item__image"
      ></div>

    </div>

    <div class="container">

      <div class="news-item news-item_full">
        
        <div
          v-html="desc"
          class="news-item__desc"
        ></div>

      </div>

      <div class="pagination pagination_news-item-page">
        
        <div
          v-show="this.prev !== null"
          class="pagination__prev"
        >
          
          <a
            @click.prevent="onClickPrevNewsLink"
            href="#"
            class="link link_gray"
          >Prev news</a>

        </div>

        <div
          v-show="this.next !== null"
          class="pagination__next"
        >
          
          <a
            @click.prevent="onClickNextNewsLink"
            href="#"
            class="link link_gray"
          >Next news</a>

        </div>

      </div>

    </div>

  </main>

</template>

<script>
  export default {
    name: 'NewsItemPage',

    props: {
      id: Number,
    },

    data() {
      return {
        date: null,
        title: null,
        shortDesc: null,
        desc: null,
        image: null,
        prev: null,
        next: null,
      };
    },

    created() {
      this.fetchData();
    },

    watch: {
      $route() {
        this.fetchData();
      },
    },

    methods: {
      fetchData() {
        this.$http.get(`/api/news/${ this.id }`)

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.date = data.date;
        this.title = data.title;
        this.shortDesc = data.short_desc;
        this.desc = data.desc;
        this.image = data.image;
        this.prev = data.prev;
        this.next = data.next;
      },

      prevNews() {
        if (this.prev !== null) {
          this.$router.push({
            name: 'NewsItem',
            params: {
              id: this.prev,
            },
          });
        }
      },

      nextNews() {
        if (this.next !== null) {
          this.$router.push({
            name: 'NewsItem',
            params: {
              id: this.next,
            },
          });
        }
      },

      onClickPrevNewsLink() {
        this.prevNews();
      },

      onClickNextNewsLink() {
        this.nextNews();
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/news/Item.vue